<template>
  <div class="container">
    <div class="img-rules"><img src="../../assets/img/banner-rules.png"/></div>
    <div class="content-font-Rules">
      <div class="bg-title">代驾</div>
      <template v-if="fixedChargeGradient && fixedChargeGradient.length == 0">
      <div class="title-Rules">计费规则区分</div>
      <div class="table-box-jf" >
        <table width="100%">
          <caption>
            起步价
          </caption>
          <tr>
            <th colspan="2" align="left">
              实际计费以开车时间为主，超出部分加收里程费
            </th>
          </tr>
          <tr v-for="(item, index) in data.startingPriceGradient" :key="index">
            <td align="left">
              {{ item.startTimeOrMileage | formatDuringDHMSFun }}-{{
              item.endTimeOrMileage | formatDuringDHMSFun
              }}
            </td>
            <td align="right">{{ item.price | calcPriceFun }}元（含{{item.mileageOrMinute}}公里）</td>
          </tr>
        </table>
        <table width="100%">
          <caption>
            里程费
          </caption>
          <tr>
            <th colspan="2" align="left">
              超出起步里程，按照时间档位收取里程费
            </th>
          </tr>
          <tr v-for="(item, index) in data.mileageFeeGradient" :key="index">
            <td align="left">
              {{ item.startTimeOrMileage | formatDuringDHMSFun }}-{{
              item.endTimeOrMileage | formatDuringDHMSFun
              }}
            </td>
            <td align="right">{{ item.price | calcPriceFun }}元/公里</td>
          </tr>
        </table>
        <table width="100%">
          <caption>
            时长费
          </caption>
          <tr>
            <th colspan="2" align="left">
              实际计费以开车时间为准，超出按照时间档位收取时长费
            </th>
          </tr>
          <tr v-for="(item, index) in data.timeCostGradient" :key="index">
            <td align="left">
              {{ item.startTimeOrMileage | formatDuringDHMSFun }}-{{
              item.endTimeOrMileage | formatDuringDHMSFun
              }}
            </td>
            <td align="right">{{ item.price | calcPriceFun }}元/分钟</td>
          </tr>
        </table>
      </div>
      <div class="title-Rules">规则说明</div>
      <dl>
        <dt>计费规则：</dt>
        <dd>
          公里数计费不足整数公里数，取整计费。时间数计费不足整数分钟时，取整计费。<br/>收费费用=起步价+里程费+时长费+远途费+等候费。
        </dd>
      </dl>
      <dl>
        <dt>起步价：</dt>
        <dd>费用以实际开车时间为准。</dd>
      </dl>
      <dl>
        <dt>远途费：</dt>
        <dd>
          代驾距离超过{{mileageOrMinute}}公里后，每超过1公里加收{{
          longDistanceChargeGradient | calcPriceFun
          }}元，不足1公里按1公里计算。
        </dd>
      </dl>
      <dl>
        <dt>等候费：</dt>
        <dd>
          司机到达后和行程中停车等候免费时长共{{ data.freeWaitTime ? data.freeWaitTime : 0}}分钟，每超出1分钟收取{{
          awaitFeeGradient | calcPriceFun
          }}元。
        </dd>
      </dl>
      <dl v-if="data.parkingWaitingGradient">
        <dt>停车等候费：</dt>
        <dd>
          行程中停车等候优先消耗{{ data.freeWaitTime ? data.freeWaitTime : 0}}分钟免费等候时长，超时按照{{ data.parkingWaitingGradient.mileageOrMinute }}分钟收取{{
          data.parkingWaitingGradient.price | calcPriceFun
          }}元，上限金额为{{ data.parkingWaitingGradient.parkingMaximumCost | calcPriceFun }}元。
        </dd>
      </dl>
      <dl>
        <dt>附加费用：</dt>
        <dd>费用取路桥费、停车费、其他费用的总和。</dd>
      </dl>
      <dl>
        <dt>减免费：</dt>
        <dd>代驾司机进行的金额减免，可用于直接抵扣车费。</dd>
      </dl>
    </template>
    <template v-if="fixedChargeGradient && fixedChargeGradient.length > 0">
      <div class="title-Rules">代驾基础费用</div>
      <div class="title-tip">实际计费以下单时间为准，预估里程区间内按一口价计费，超出部分加收超里程费</div>
      <div class="table-box-jf">
        <template v-for="(item, index) in fixedChargeGradient">
            <table width="100%">
                <caption :key="index">时间段：{{ item.startTime | formatDuringDHMSFun}} - {{ item.endTime | formatDuringDHMSFun}}</caption>
                <tr :key="index">
                    <th align="left" class="fixed">预估里程区间</th>
                    <th align="center" class="fixed">一口价</th>
                    <th align="right" class="fixed">超里程费</th>
                </tr>
                <tr v-for="(item1, index1) in item.fixedFeeRuleList" :key="index1">
                    <td align="left" class="fixed">{{item1.startTimeOrMileage | meters}}-{{item1.endTimeOrMileage | meters}} 公里</td>
                    <td align="center" class="fixed">{{item1.price | calcPriceFun}} 元</td>
                    <td align="right" class="fixed">{{item1.overMileageFee | calcPriceFun}} 元/公里</td>
                </tr>
            </table>
        </template>
      </div>
      <div class="title-Rules">代驾计费规则</div>
      <dl>
        <dt class="fixed">1.超出里程公里数计费不足整数公里时，取整计费。</dt>
        <dd></dd>
      </dl>
      <dl>
        <dt class="fixed">2.收费费用=一口价+超出里程*超里程费。</dt>
        <dd></dd>
      </dl>
      <dl>
        <dt class="fixed">3.实际费用以下单时间为准。</dt>
        <dd></dd>
      </dl>
    </template>
    </div>
  </div>
</template>

<script>
  import mobileType from '../../utils/mobileType';
  import util from '../../utils/util';
  import { getMyInfo, getChargingCityDetailCar } from '@/apis/order/order';

  export default {
    data() {
      return {
        userType: null,
        orderType: null,
        channelType: 1,
        data: {},
        timeFramePrice: [],
        cityCode: '',
        awaitFeeGradient: '',
        longDistanceChargeGradient: '',
        mileageOrMinute: '',
        fixedChargeGradient: []
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      if (this.$route.query.data) {
        let data = decodeURIComponent(this.$route.query.data);
        this.data = JSON.parse(data);
      }
      // this.getMyInfoFun();
      this.getUserInfoFromApp();
    this.getInfo()
    },
    filters: {
      calcPriceFun(val) {
        return util.calcPrice(val);
      },
      meters(val) {
        if (val) {
          return val / 1000;
        } else {
          return 0;
        }
      },
      formatDuringDHMSFun(val) {
        if (val == 0) {
          return '00:00:00';
        } else {
          return util.formatDuringDHMS(val);
        }
      },
    },
    methods: {
      getUserInfoFromApp() {
        let params = {
          methodName: 'getDataFromNative', //定义与原生的方法名(固定)
          type: 1, //业务类型(固定)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
      getDataFromNative(params) {
        if (mobileType.isIOS()) {
          this.params = params;
        } else if (mobileType.isAndroid()) {
          this.params = JSON.parse(params);
        }
        this.getMyInfoFun();
      },
      // 获取userType
      async getMyInfoFun() {
        // let params = {
        //   areaCode: 110105,
        //   channel: '1020000000',
        //   deviceId: '076cf0ae-9f57-44d4-b59a-9590dedbf65b',
        //   display: '1080*2340',
        //   imei: '00000000-0000-0000-0000-000000000000',
        //   imsi: '未授权电话权限',
        //   platform: '1',
        //   softVersion: '13.4.1',
        //   sysVersion: 'TNY-AL00,10',
        //   data: {},
        //   token: 'MTAxMTAwMDQ0NjoxMDA6MjAyMTA1MTgxNzE5NDM2MTM='
        // };
        let params = {
          areaCode: this.params.areaCode,
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          display: this.params.display,
          imei: this.params.imei,
          imsi: this.params.imsi,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          data: {},
          token: this.params.token,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getMyInfo(params);
          if (data.code == 1 && data.data) {
            let userType = JSON.parse(data.data).daijiaVip;
            console.log(this.data);
            this.getInfo(userType);
          }
        } catch (error) {
        }
      },
      // 获取数据
      async getInfo(userType) {
        // let params = {
        //   areaCode: 110105,
        //   channel: '1020000000',
        //   deviceId: '076cf0ae-9f57-44d4-b59a-9590dedbf65b',
        //   display: '1080*2340',
        //   imei: '00000000-0000-0000-0000-000000000000',
        //   imsi: '未授权电话权限',
        //   platform: '3',
        //   softVersion: '13.4.1',
        //   sysVersion: 'TNY-AL00,10',
        //   data: {
        //     cityCode: '110100',
        //     userType: 2,
        //     orderType: 2,
        //     chargeType: 4,
        //     channelType: this.channelType,
        //   },
        //   token: 'MTAxNzAwMTE3OjcwMDoyMDIzMDUwNjE1MjAwNjM1MTpmZmZmZmZmZi1jZDYzLTY2ZDEtZmZmZi1mZmZmZWYwNWFjNGE\u003d'
        // };
        let params = {
          areaCode: this.params.areaCode,
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          display: this.params.display,
          imei: this.params.imei,
          imsi: this.params.imsi,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          data: {
            areaCode: this.params.areaCode || this.data.areaCode ||  this.data.cityCode,
            cityCode: this.data.cityCode,
            userType: userType == 3 ? 3 : 2,
            orderType: this.data.orderType,
            channelType: this.channelType,
            lat: this.data.lat,
            lon: this.data.lon,
            orderId: this.data.orderId,
            chargeType: this.data.chargeType
          },
          token: this.params.token,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getChargingCityDetailCar(params);
          if (data.code == 1 && data.data) {
            //   this.data = JSON.parse(data.data).list[0];
            //   this.timeFramePrice = JSON.parse(data.data).list[0].timeFramePrice;
            //   console.log(this.data);

            this.data = JSON.parse(data.data);
            if(this.data.awaitFeeGradient && this.data.awaitFeeGradient.length){
                this.awaitFeeGradient = this.data.awaitFeeGradient[0].price;
            }
            if(this.data.longDistanceChargeGradient && this.data.longDistanceChargeGradient.length){
                this.longDistanceChargeGradient = this.data.longDistanceChargeGradient[0].price;
                this.mileageOrMinute = this.data.longDistanceChargeGradient[0].mileageOrMinute;
            }
            this.fixedChargeGradient = this.data.fixedChargeGradient;
          }
        } catch (error) {
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .img-rules {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .content-font-Rules {
    padding: 0 3rem 1.5rem 3rem;

    .bg-title {
      background: url("../../assets/img/bg-rules-title.png") no-repeat center bottom;
      background-size: 2.25rem 0.5rem;
      text-align: center;
      font-size: 0.9375rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 1.3125rem;
      padding-top: 1.5rem;
    }

    .title-Rules {
      padding-top: 1.5rem;
      padding-bottom: 0.5rem;
    }

    dl {
      padding-bottom: 0.5rem;

      dt {
        font-size: 12px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 17px;
        float: left;
      }
      dt.fixed {
        color: rgba(153, 153, 153, 1);
      }
      dd {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
        margin-left: 4.5rem;
      }
    }
  }

  .table-box-jf {
    table {
      border-bottom: solid 1px #ececec;
      padding-bottom: 1rem;

      caption {
        text-align: left;
        font-size: 15px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        padding-top: 1rem;
        padding-left: 3px;
      }

      tr {
        th {
          font-size: 12px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          padding-top: 0.5rem;
          padding-bottom: 0.25rem;
        }
        th.fixed {
            color: rgba(51, 51, 51, 1);
        }
        td {
          font-size: 12px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 17px;
          padding-top: 0.5rem;
        }
        td.fixed {
            color: rgba(153, 153, 153, 1);
        }
      }
    }
  }
  .title-tip {
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 17px;
  }
</style>
